// Update the delivery settings
$(document).ready(function () {

  var utils = {
    setPopUp: function (popupId, closeId, html) {
      if ($(`#${popupId}`).length > 0) {
        $(`#${popupId}`).show();
      } else {
        if($('.warning-popup').length > 0){
           $('.warning-popup .warning-popup__content').append($(`<hr>${html}`));
           return;
        }
        var newNode = $(
          `<div class='warning-popup' id='${popupId}'><div class="warning-popup__content"><h2>Warning</h2>${html}</div><a href='#' id='${closeId}' class='warning-popup__close'><svg class='warning-popup__close' width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd'><path d='M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm0 10.293l5.293-5.293.707.707-5.293 5.293 5.293 5.293-.707.707-5.293-5.293-5.293 5.293-.707-.707 5.293-5.293-5.293-5.293.707-.707 5.293 5.293z'></path></svg></a></div>`
        );
          $("body").append(newNode);
          setPopupEvent();
          function setPopupEvent() {
            $(`#${closeId}`).click(function () {
              $(`#${popupId}`).hide();
            });
          }
      }
    },
  };

  class PreOrder {
    constructor() {
      this.orderType = this.checkPreOrderItem();
      this.year = new Date().getFullYear();
      this.deliveryStartDate = new Date(`${this.year}-12-16`);
      this.deliveryEndDate = new Date(`${this.year}-12-23`);
      this.deliveryStartDateStamp = this.deliveryStartDate.getTime();
      this.deliveryEndDateStamp = this.deliveryEndDate.getTime();
    }
    observeCart() {
      var that = this;
      var observer = new MutationObserver(function () {
        that.orderType = that.checkPreOrderItem();
      });
      let config = {
        attributes: true,
      };
      observer.observe(document.querySelector("#CartContainer"), config);
    }
    checkPreOrderItem() {
      let preOder = 0,
        normalOrder = 0,
        orderAmount = 0;

      $(".grid.product").each(function () {
        orderAmount++;
        let isPreordered = $(this).find(".Note");
        if (isPreordered.length === 0) {
          normalOrder++;
          return;
        }
        preOder++;
      });

      if (preOder === orderAmount) {
        return "preorder";
      } else if (normalOrder === orderAmount) {
        return "normal";
      } else {
        return "mix";
      }
    }
    init() {
      // preorder && mixorder
      // mixorder ====> popup
      if (this.orderType !== "normal") {
        this.watchDatePicker();
        if (this.orderType === "mix") {
          var html =
            "<div><h2>Warning: you have pre-order and in-stock items in the same cart</h2><p>Your cart items won't be shipped before pre-order items are available. (Delivery date for pre-order items <strong>starts on 17th of December</strong>.)<br>To get your in-stock items delivered earlier, please make two separate orders - one for your pre-order items and one for your in-stock items.</p></div>";
          utils.setPopUp(
            "preorder-warning-popup",
            "preorder-warning-popup__close",
            html
          );
        }
      }
      this.observeCart();
    }
    watchDatePicker() {
      if ($(".picker__holder").length === 0) {
        var that = this;
        // console.log(this);
        var interval = setInterval(() => {
          if ($(".picker__holder").length > 0) {
            clearInterval(interval);
            that.getSelectedDate();
          }
        }, 500);
      }
    }
    ableCheckout() {
      clearInterval(this.interval4Btn);
      $(".cart__checkout").attr("disabled", false);
    }
    getSelectedDate() {
      var that = this,
        selectedDateStamp;
      this.inputwatcher = setInterval(() => {
        if ($('input[name="zpDate"]').length > 0) {
          that.disablePickers();
          var selectedDate = $('input[name="zpDate"]').attr("value");
          if (selectedDate !== "undefined" && selectedDate) {
            var newStamp = new Date(selectedDate).getTime();
            if (newStamp !== selectedDateStamp) {
              selectedDateStamp = newStamp;
              var readyToCheckOut = that.goodDeliveryDate(selectedDateStamp);
              if (readyToCheckOut) {
                that.getready();
                clearInterval(that.interval4pickers);
              } else {
                // that.keepCheckOutDisabled();
                // that.addwarning();
              }
            }
          }
        }
      }, 500);
    }
    keepCheckOutDisabled() {
      this.interval4Btn = setInterval(() => {
        if (!$(".cart__checkout").attr("disabled")) {
          $(".cart__checkout").attr("disabled", "disabled");
        }
      }, 500);
    }
    addwarning() {
      if ($(".cart__checkout-wrapper").find("#wrongDate").length > 0) {
        return;
      }
      var newNode = $(
        '<p id="wrongDate" class="error">Please choose a date between 17th to 23th of December for pre-order products</p>'
      );
      newNode.insertAfter($("#storePickupApp"));
    }
    removewarning() {
      $("#wrongDate").remove();
    }
    disablePickers() {
      //Recheck the order type
      if (this.orderType !== "normal") {
        var that = this;
        $(".picker__day").each(function () {
          var dateStamp = $(this).attr("data-pick");
          if (!that.goodDeliveryDate(dateStamp)) {
            if (!$(this).hasClass("picker__day--disabled")) {
              $(this).addClass("picker__day--disabled");
            }
          }
        });
      }
    }
    goodDeliveryDate(selectedDateStamp) {
      return (
        selectedDateStamp < this.deliveryEndDateStamp &&
        selectedDateStamp > this.deliveryStartDateStamp
      );
    }
    getready() {
      this.ableCheckout();
      this.removewarning();
    }
  }




  // Shiralee Butcher order stops at 8am for next day order
  class OrderLimit {
    constructor(vendor, limitStamp, popUpMessage) {
      this.limitedProductVendor = vendor;
      this.limitStamp = limitStamp;
      this.popUpMessage = popUpMessage;
      this.limitedProducts = [];
      // this.todayStamp = (new Date('2021-11-26 8:01')).getTime();
      this.today = new Date().getDate();
      this.nowhour = new Date().getHours();
      this.selectedDate = "";
    }
    init() {
      debugger;
      this.hasLimitedProducts();
      this.observeCart();
      this.triggerTheObserver();
    }
    observeCart() {
      var that = this;
      var observer = new MutationObserver(function () {
        if (!that.hasLimitedProducts()) {
          that.ableCheckout.apply(that);
        } else {
          setTimeout(() => {
            that.selectedDate = "";
          }, 1000);
        }
        //         console.log(that.limitedProducts, that.hasLimitedProducts());
      });
      let config = {
        attributes: true,
      };
      if(document.querySelector("#CartContainer")){
      observer.observe(document.querySelector("#CartContainer"), config);
      }
    }
    hasLimitedProducts() {
      var that = this;
      this.limitedProducts = [];
      $(".grid.product").each(function (index, item) {
        if ($(item).attr("data-vendor") === that.limitedProductVendor) {
          var productName = $(item).find("a.cart__product-name").text().trim();
          that.getProductList(productName);
          return;
        }
        //Disable tuesday delivery for verdor THE BREAD AND BUTTER PROJECT
        if ($(item).attr("data-vendor") === 'THE BREAD AND BUTTER PROJECT') {
          that.disablePickers('Tue');
          return;
        }
      });
    }
    disablePickers(forbiddenDate){
      this.inputwatcher = setInterval(() => {
        if ($('input[name="datetime"]').length > 0) {
        var that = this;
        $(".picker__day").each(function () {
          if (!$(this).hasClass("picker__day--disabled")) {
          var date = $(this).attr("aria-label");
          console.log(date);
          if (date.indexOf(forbiddenDate)>-1) {
              $(this).addClass("picker__day--disabled");
          }
          }
        });
        }
      }, 500);
      
    }
    getProductList(productName) {
      if (this.limitedProducts.indexOf(productName) === -1) {
        this.limitedProducts.push(productName);
      }
    }
    triggerTheObserver() {
      if ($(".Zapiet-Calendar").length === 0 || !$('input[name="datetime"]').val()) {
        var that = this;
        // console.log(this);
        var interval = setInterval(() => {
          if ($('input[name="datetime"]').val()) {
            clearInterval(interval);
            that.getSelectedDate();
          }
        }, 500);
      }
    }
    getSelectedDate() {
      debugger;
      var that = this;
      var inputwatcher = setInterval(() => {
        debugger;
        if ($('input[name="datetime"]').length > 0) {
          var selectedDate = $('input[name="datetime"]').val();
          if (selectedDate !== "undefined" && selectedDate) {
            if (selectedDate !== that.selectedDate) {
              that.selectedDate = selectedDate;
              that.validateOrder(selectedDate);
            }
          }
        }
      }, 500);
    }
    validateOrder(selectedDate) {
      // Check if there're any limited products(Shiralee meat);
      if (this.limitedProducts.length > 0) {
        if(this.limitedProductVendor == 'Moofish'){
          this.checkFishOrder(selectedDate);
        }else if(this.limitedProductVendor == 'Healthy Bake'){
          this.checkHealthyOrder(selectedDate);
        }
        else{
        this.checkShiraleeMeatOrder(selectedDate);
        }
      } else {
        this.checkNormalOrder(selectedDate);
      }
    }
    
    checkShiraleeMeatOrder(selectedDate){
      // Check the time
      // If delivery date is tomorrow
      // And order time is after 8am
      // Then disable check out button and notify the customer to choose another date
      var deliveryStamp = new Date(selectedDate).getTime();
      var delivery = new Date(selectedDate);
      var deliveryDay = parseInt((delivery).getDay());
      // var todayStamp = new Date('2023/10/09 11:29').getTime();
      var todayStamp = new Date().getTime();
//       var todayStamp = new Date("2022/01/28 8:40").getTime();
      // 57600000 is the stamp difference from today 8am to tomorrow
      debugger;
      // 93600000 is the stamp difference from yesterday 10pm to tomorrow
      if (deliveryStamp - todayStamp <= this.limitStamp || deliveryDay === 2) {
        // Check if there's limited products;
        // console.log(this.limitedProducts.length);
        this.keepCheckOutDisabled();
        this.setPopUp();
      } else {
        this.ableCheckout();
        debugger;
      // 59400000 is the stamp difference from today 9:30am to tomorrow
        if (deliveryStamp - todayStamp <= 95400000 ) {
          var text =
            '<span class="warning-text-top"> As we process meat products fresh every day, this cart needs to be submitted by 10pm for delivery!Time left:</span>';
          setTimeout(() => {
              this.triggerCountDown(text, "");
          }, 100);
        } else {
          this.hideCountDown(selectedDate, new Date().getDate());
        }
      }
    }
    checkHealthyOrder(selectedDate){
      var delivery = new Date(selectedDate);
      var deliveryDay = parseInt((delivery).getDay());
      if(deliveryDay === 1 || deliveryDay === 2 || deliveryDay === 7){
        this.keepCheckOutDisabled();
        this.setPopUp();
        return
      }
      this.ableCheckout();
    }
    checkFishOrder(selectedDate){
      var delivery = new Date(selectedDate);
      var deliveryMonth = parseInt((delivery).getMonth());
      var deliveryDay = parseInt((delivery).getDay());
      var deliveryDate = parseInt((delivery).getDate());
      var today = new Date();
      // var today =new Date('2022/04/11 06:59');
      var todayMonth = parseInt((today).getMonth());
      var todayDay = parseInt((today).getDay());
      var todayDate = parseInt((today).getDate());
      var todayTime = parseInt((today).getHours());
      var deliveryStamp = new Date(selectedDate).getTime();
      var todayStamp = new Date().getTime();
      if(deliveryDay === 1 || deliveryDay === 2 || deliveryDay === 0){
        this.keepCheckOutDisabled();
        this.setPopUp();
        return
      }
      debugger;
      if(deliveryDate - todayDate <= 3 && deliveryMonth === todayMonth ){
        // Wed/Thurs delivery
        if(deliveryStamp - todayStamp > 147600000){
          if(deliveryDay === 2 || deliveryDay === 4){
            if((todayDay === 1 && todayTime < 7) || todayDay < 1){
              // eligible for checkout 
              if (todayTime === 6 ) {
                var text =
                  '<span class="warning-text-top"> As we process products fresh every day, this cart needs to be submitted by 7am! Time left:</span>';
                this.triggerCountDown(text, "");
              } else {
                this.hideCountDown(selectedDate, new Date().getDate());
              }
              this.ableCheckout();
              return
            }
          }else if (deliveryDay === 5 || deliveryDay === 6){
            if((todayDay === 3 && todayTime < 7) || todayDay < 3){
              // eligible for checkout 
              if (todayTime === 6) {
                var text =
                  '<span class="warning-text-top"> As we process products fresh every day, this cart needs to be submitted by 7am!Time left:</span>';
                this.triggerCountDown(text, "");
              } else {
                this.hideCountDown(selectedDate, new Date().getDate());
              }
              this.ableCheckout();
              return
            }
          }
        }
          
        this.keepCheckOutDisabled();
        this.setPopUp();
        return
      }
      this.ableCheckout();
    }
    checkNormalOrder(selectedDate){
      //If there's no Shiralee Meat and the order is for tomorrow, set a count down if current time is after 11am
      var deliveryDate = new Date(selectedDate).getDate();
      // console.log(deliveryDate);
      var todayDate = new Date().getDate();
      var todayHours = new Date().getHours();
//       var todayDate = 28;
//       var todayHours = 11;
      if (deliveryDate - todayDate === 1 && todayHours === 11) {
        var text =
          '<span class="warning-text-top"> This cart needs to be submitted by 12pm for delivery tomorrow! Time left:</span>';
        var textToReplace =
          "Sorry we're not accepting orders for delivery tommorrow anymore. Please choose a different delivery date. Thank you for your understanding. ";
        this.triggerCountDown(text, textToReplace);
      }else{
        this.hideCountDown(deliveryDate, todayDate);
      }
    }
    triggerCountDown(text, textToReplace) {
      var mins = new Date().getMinutes();
      var secs = new Date().getSeconds();
  
//       var mins = 60;
//       var secs = 50;
      var countDownMinsBase, countDownMins,countDownSecsBase,countDownSecs;
      countDownMinsBase = countDownMins = 60 - mins;
      countDownSecsBase = countDownSecs = 60 - secs;
  
      if ($(".count-down_container").length > 0) {
        return;
      }
      var circleHtml = `<div class="circle">      <svg class="svg-circle-1" width="150" height="150" xmlns="http://www.w3.org/2000/svg">
      <g>
       <title>Layer 1</title>
       <circle id="circle" class="circle_animation" r="60" cy="75" cx="75" stroke-width="7" stroke="#EE6441" fill="none"/>
      </g>
     </svg><svg class="svg-circle-2" width="150" height="150" xmlns="http://www.w3.org/2000/svg">
     <g>
      <title>Layer 2</title>
      <circle id="circle" class="circle_animation" r="60" cy="75" cx="75" stroke-width="7" stroke="#EEEEEE" fill="none"/>
     </g>
    </svg></div>`;
      var clock = `<div class="clock"><div class="h3"><p id='mins'>${filterNumber(
        countDownMins
      )}</p><p class="divider">:</p><p id='secs'>${filterNumber(
        countDownSecs
      )}</p></div><div class="notes"><p>Mins</p><p>Secs</p></div></div>`;
      var html = `<div class='count-down_container'><div><p class="text-warning">Warning:</p>${text} </div><div class='count-down'>${clock} ${circleHtml}</div><p class="warning-text-bottom">If completed after the deadline we cannot guarantee availability! Thank you for your understanding.</p></div>`;
      var container = $("#storePickupApp");
      container.append(html);
  
      var strokeOffsetStart = 376.99;
      $(".svg-circle-2").css("stroke-dasharray", strokeOffsetStart);
      $(".svg-circle-2").css("stroke-dashoffset", strokeOffsetStart);
      $(".svg-circle-2").css("opacity", 1);
  
      //Let countDown Scroll Into View;
      if ($(".count-down_container").closest('#CartDrawer').length>0) {
        $(".count-down_container")[0].scrollIntoView();
      }
      var countDownMinsElm = $("#mins");
      var countDownSecsElm = $("#secs");
      var countDown = setInterval(() => {
        if (countDownMins === 0 && countDownSecs === 0) {
          clearInterval(countDown);
          if (textToReplace != "") {
            $(".warning-text-top").text(textToReplace);
            $(".warning-text-bottom").text("");
            $("button.cart__checkout").prop("disabled", true);
          }
          return;
        }
        if (countDownSecs === 0) {
          countDownMins -= 1;
          countDownSecs = 60;
          countDownMinsElm.text(filterNumber(countDownMins));
          countDownSecsElm.text(filterNumber(countDownSecs));
        } else {
          countDownSecs -= 1;
          countDownSecsElm.text(filterNumber(countDownSecs));
        }
        var countDownMinsAllBase = countDownMinsBase * 60 + countDownSecsBase;
        var countDownMinsAllNow = countDownMins * 60 + countDownSecs;
        var strokeOffsetNow =
          (countDownMinsAllNow / countDownMinsAllBase) * strokeOffsetStart;
        $(".svg-circle-2").css("stroke-dashoffset", strokeOffsetNow);
      }, 1000);
  
      function filterNumber(number) {
        if (number - 10 < 0) {
          number = "0" + number;
        }
        return number;
      }
    }
    hideCountDown(selectedDate, todayDate){
      if (selectedDate - todayDate === 1) {
        return
      }
      if ($(".count-down_container").length > 0) {
        $(".count-down_container").remove();
      }
    }
    keepCheckOutDisabled() {
      var that = this;
      this.interval4Btn = setInterval(() => {
        if (!$(".cart__checkout").attr("disabled")) {
          $(".cart__checkout").attr("disabled", "disabled");
        }
      }, 500);
    }
    ableCheckout() {
      clearInterval(this.interval4Btn);
      $(".cart__checkout").attr("disabled", false);
    }
    setPopUp() {
      if ($("#shiralee-warning-popup").length) {
        $("#shiralee-warning-popup").remove();
      }
      var productHtml = '<div class="shiralee-list"><p>Products:</p><ul>';
      for (let index = 0; index < this.limitedProducts.length; index++) {
        const element = this.limitedProducts[index];
        productHtml += `<li>${element}</li>`;
      }
      productHtml += "</ul></div>";
      var html = `${this.popUpMessage}${productHtml}`;
      var handle = this.limitedProductVendor.replace(' ', '-')
      utils.setPopUp(
        `${handle}-warning-popup`,
        `${handle}-warning-popup__close`,
        html
      );
    }
  }

  function checkOrder() {
    // const preOrder = new PreOrder();
    // preOrder.init();
    const popUpMessage = '<p>The following products must be ordered before <span> 10pm 2 days prior</span>(not available for Tuesday).<br> Please remove the following products or choose a different delivery day.</p>';
    // const popUpMessage = '<p> The following product must be ordered by <span>10am Monday</span> for <span>Wed/Thurs delivery</span> or <span>10am Wednesday</span> for <span>Friday/Saturday</span>. <br>Please remove the following products or choose a different delivery day.</p>';
    const shiraleeLimit = new OrderLimit("Shiralee Meat", 93600000, popUpMessage);
    const thisisus = new OrderLimit("This Is Us PreOrder", 93600000, popUpMessage);
    const fishpopUpMessage = '<p> The following product must be ordered by <span>7am Monday</span> for <span>Wed/Thurs delivery</span> or <span>7am Wednesday</span> for <span>Friday/Saturday</span>. <br>Please remove the following products or choose a different delivery day.</p>';
    // const fishpopUpMessage = '<p>The following products must be ordered before <span> 7am 2 days prior</span>.<br> Please remove the following products or choose a different delivery day.</p>';
    const fishLimit = new OrderLimit("Moofish", 147600000, fishpopUpMessage);
   // const shiraleeLimit = new OrderLimit("Shiralee Meat", 147600000, fishpopUpMessage);
    const bakepopUpMessage = '<p> The following product must be ordered from Thursday. <br>Please remove the following products or choose a different delivery day.</p>';
    const bakeLimit = new OrderLimit("Healthy Bake", '', bakepopUpMessage);
    shiraleeLimit.init();
    setTimeout(() => {
      fishLimit.init();
    }, 500);
    setTimeout(() => {
      bakeLimit.init();
    }, 700);
    setTimeout(() => {
      thisisus.init();
    }, 710);
  }
  function initPreOrderFuns() {
    
    // Check if the user is on the cart page or opened the cart drawer
    if (window.location.href.indexOf("cart") > 0) {
      checkOrder();
    } else {
      function observeDrawer() {
        function initPreOrder() {
          observer.disconnect();
          checkOrder();
        }
        var observer = new MutationObserver(initPreOrder);
        let config = {
          attributes: true,
        };
        observer.observe(document.querySelector("#CartDrawer"), config);
      }
      // observeDrawer();
    }
  }

  initPreOrderFuns();
});
